export interface ContactSupportFormData {
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
}

/** Form field names; derived so slice and form stay in sync with ContactSupportFormData. */
export type ContactSupportFormField = keyof ContactSupportFormData;

/** Validation errors keyed by form field. */
export type FieldErrors = Partial<Record<ContactSupportFormField, string>>;

/** Payload sent to the API (same shape as form data). */
export type ContactSupportPayload = ContactSupportFormData;

/** Redux state: form values (all strings for controlled inputs) + UI state. */
export interface ContactSupportState
  extends Record<ContactSupportFormField, string> {
  isSubmitting: boolean;
  showConfirmation: boolean;
  errors: FieldErrors;
  submitError: string | null;
}

/** Initial form values for slice and validation; single source for "empty" fields. */
export const INITIAL_CONTACT_SUPPORT_FORM: Record<
  ContactSupportFormField,
  string
> = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};
